var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunflower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 55,
    fill: "none",
    viewBox: "0 0 50 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.0224 44.963L24.3706 44.0371V55.0001H27.0224V53.7752C27.7089 54.1122 28.7189 53.951 30.0204 53.404C32.2338 52.4739 33.9737 48.5927 33.9737 48.5927C30.3033 47.7807 28.144 48.1655 27.0224 49.1559V44.963Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M42.9184 19.46L49.469 24.0824L42.8655 28.7577L46.2201 36.048L38.2959 36.7612L37.5827 44.6854L30.3189 41.3044L25.6964 47.855L21.0212 41.2515L13.7309 44.6061L13.0177 36.6819L5.09351 35.9687L8.4745 28.7049L1.92383 24.0824L8.52733 19.4071L5.17275 12.1169L13.097 11.4037L13.8101 3.4795L21.074 6.86049L25.6964 0.309814L30.3717 6.91332L37.662 3.55874L38.3752 11.4829L46.2994 12.1961L42.9184 19.46ZM12.4894 24.0824C12.4894 31.3765 18.4024 37.2894 25.6964 37.2894C29.1992 37.2894 32.5584 35.898 35.0352 33.4212C37.512 30.9444 38.9034 27.5851 38.9034 24.0824C38.9034 16.7884 32.9905 10.8754 25.6964 10.8754C18.4024 10.8754 12.4894 16.7884 12.4894 24.0824Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.697,
    cy: 24.082,
    r: 11.37,
    fill: "#fff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunflower);
export default __webpack_public_path__ + "static/media/sunflower.7377623e521c42930ee53836beb2d82b.svg";
export { ForwardRef as ReactComponent };